import { clientVersion } from '@/constants/env';

const fullInstrumentTypeCascaderOption = [
  {
    value: '',
    label: '沉陷類',
    children:[
      {
        value: 'BM (永久水準點)',
        label: 'BM (永久水準點)',
      },{
        value: 'SB (沉陷計)',
        label: 'SB (結構物或基礎沈陷點)',
      },{
        value: 'SG (地面型沈陷點)',
        label: 'SG (地面型沈陷點)',
      },{
        value: 'SM (混凝土/瀝青鋪面型沉陷點)',
        label: 'SM (混凝土、瀝青舖面型沉陷點)',
      },{
        value: 'SU (公共管線沈陷點)',
        label: 'SU (公共管線沈陷點)',
      },{
        value: 'BRT (隧道沈陷岩釘)',
        label: 'BRT (隧道沈陷岩釘)',
      },{
        value: 'SSI (淺式沈陷計)',
        label: 'SSI (淺式沈陷計)',
      },{
        value: 'SP (沈陷板)',
        label: 'SP (沈陷板)',
      },{
        value: 'HI (隆起桿)',
        label: 'HI (隆起桿)',
      },
    ],
  },
  {
    value: '',
    label: '傾斜類',
    children:[
      {
        value: 'TI (傾斜計)',
        label: 'TI (房屋傾斜計)',
      },
    ],
  },
  {
    value: '',
    label: '地層位移類',
    children:[
      {
        value: 'EXM (多點伸縮儀)',
        label: 'EXM (多點伸縮儀)',
      },
      {
        value: 'EXS (單點伸縮儀)',
        label: 'EXS (單點伸縮儀)',
      },
      {
        value: 'SID (連續壁內傾度管)',
        label: 'SID (連續壁內傾度管)',
      },
      {
        value: 'SIS (傾斜儀)',
        label: 'SIS (土壤中傾度管)',
      },
      {
        value: 'ISS (傾斜)',
        label: 'ISS (傾斜)',
      },
      {
        value: 'ISS (測沉)',
        label: 'ISS (測沉)',
      },
    ],
  },
  {
    value: '',
    label: '水位水壓類',
    children:[
      {
        value: 'OW (水位觀測井)',
        label: 'OW (水位觀測井)',
      }, {
        value: 'ELP (水壓計)',
        label: 'ELP (電子式感應水壓計)',
      }, {
        value: 'PS (豎管式水壓計)',
        label: 'PS (豎管式水壓計)',
      }, {
        value: 'EP (土壓計)',
        label: 'EP (土壓計)',
      }, {
        value: 'EP (水壓計)',
        label: 'EP (水壓計)',
      },{
        value: 'PP (氣壓式水壓計)',
        label: 'PP (氣壓式水壓計)',
      }, {
        value: 'PZ (襯砌水壓計)',
        label: 'PZ (襯砌水壓計)',
      }, {
        value: 'EPL (壁內土壓計)',
        label: 'EPL (壁內土壓計)',
      },
    ],
  },
  {
    value: '',
    label: '應力壓力類',
    children:[
      {
        value: 'RS (鋼筋計)',
        label: 'RS (鋼筋應力計)',
      },
      {
        value: 'CS (混凝土應變儀)',
        label: 'CS (混凝土應變儀)',
      },
      {
        value: 'PC (襯砌應力計)',
        label: 'PC (襯砌應力計)',
      },
      {
        value: 'LC (支撐荷重計)',
        label: 'LC (支撐荷重計)',
      },
      {
        value: 'VG (支撐應變計)',
        label: 'VG (支撐用應變計)',
      },
    ],
  },
  {
    value: '',
    label: '裂縫收斂類',
    children:[
      {
        value: 'CB (建物收斂觀測點)',
        label: 'CB (建物收斂觀測點)',
      },
      {
        value: 'CP (襯砌收斂觀測點)',
        label: 'CP (襯砌收斂觀測點)',
      },
      {
        value: 'CG (裂縫計)',
        label: 'CG (裂縫計)',
      },
      {
        value: 'CM (裂縫計)',
        label: 'CM (裂縫儀)',
      },
    ],
  },
];

const thsrInstrumentTypeCascaderOption = [
  {
    value: '',
    label: '傾斜類',
    children: [
      {
        value: 'TI (傾斜計)',
        label: 'TI (結構物傾斜計)',
      },
    ],
  },
  {
    value: '',
    label: '地層位移類',
    children: [
      {
        value: 'EXM (多點伸縮儀)',
        label: 'EXM (層別沉陷計)',
      },
      {
        value: 'SIS (傾斜儀)',
        label: 'SIS (地中傾度管)',
      },
    ],
  },
  {
    value: '',
    label: '水位水壓類',
    children: [
      {
        value: 'OW (水位觀測井)',
        label: 'OW (水位觀測井)',
      },
    ],
  },
  {
    value: '',
    label: '裂縫收斂類',
    children: [
      {
        value: 'CG (裂縫計)',
        label: 'CG (裂縫計)',
      },
    ],
  },
];

const isThsr = clientVersion === 'thsr-main' || clientVersion === 'thsr-rain';

const InstrumentTypeCascaderOption = isThsr
  ? thsrInstrumentTypeCascaderOption
  : fullInstrumentTypeCascaderOption;

const TemplateDownloadLinkSelectOption = [{
  value: `${process.env.VUE_APP_IMAGE_BASE_URL}/template/import/沉陷類-日報.xlsx`,
  label: '沉陷類(BM/SB/SG/SM/SU/BRT/SSI/SP/HI)',
},{
  value: `${process.env.VUE_APP_IMAGE_BASE_URL}/template/import/傾斜類-日報.xlsx`,
  label: '傾斜類(TI)',
},{
  value: `${process.env.VUE_APP_IMAGE_BASE_URL}/template/import/地層位移類-日報.xlsx`,
  label: '地層位移類(EXM/EXS/SID/SIS/ISS)',
},{
  value: `${process.env.VUE_APP_IMAGE_BASE_URL}/template/import/水位水土壓類-日報.xlsx`,
  label: '水位水土壓類(OW/ELP/PS/EP/PP/PZ/EPL)',
},{
  value: `${process.env.VUE_APP_IMAGE_BASE_URL}/template/import/應力應變類-日報.xlsx`,
  label: '應力應變類(RS/CS/PC/LC/VG)',
},{
  value: `${process.env.VUE_APP_IMAGE_BASE_URL}/template/import/裂縫收斂類-日報.xlsx`,
  label: '裂縫收斂類(CB/CP/CG/CM)',
}];

export {
  InstrumentTypeCascaderOption,
  TemplateDownloadLinkSelectOption,
};
